.root {
  display: grid;
  gap: var(--spacingMd);
}

.hiddenCategoryContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacingMd);
}

.detailsRow {
  display: grid;
  grid-template-columns: 3fr 1fr auto;
  gap: var(--spacingMd);
}

.tabs {
  justify-content: space-around;
  margin-bottom: var(--spacingLg);
}
